import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { ChipsContainer } from '@pascal/pascal-core';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';
import { doBetStore } from '../../store/doBetStore';
import { winningAmountStore } from '../../store/winningAmountStore';
import { gameStore } from '../../store/gameStore';

export const ChipActionWrapper = observer(() => {
  const { quickBets, setDouble, setUndoBet, lastBetModel, selectedChip, setSelectedChip } =
    doBetStore;
  const { isBetsClosed } = gameStore;
  const { setLastWin } = winningAmountStore;
  const { activeFreeBet } = freeBetStore;

  const handleSelectChips = useCallback(
    (chip) => {
      setSelectedChip(chip);
    },
    [setSelectedChip]
  );

  const handleDoubleBet = useCallback(() => {
    setLastWin(0);
    setDouble();
  }, [setDouble, setLastWin]);

  if (isBetsClosed) {
    return null;
  }

  return (
    <div className='chips-row'>
      {/* Add class // active // chips-action */}
      <div
        className={`chips-action ${lastBetModel?.betModel ? '' : 'disabled'}`}
        onClick={setUndoBet}
      >
        <div className='chips-action-inside'>
          <i className='icon-undo' />
        </div>
      </div>
      <div className={`chips-holder ${activeFreeBet.id ? 'free-chip-count' : ''}`}>
        <ChipsContainer
          selectedChip={selectedChip}
          handleSelectChips={handleSelectChips}
          quickBets={quickBets}
          isFreeChip={!!activeFreeBet.id}
        />
      </div>
      <div
        className={`chips-action ${
          !lastBetModel?.betModel || !!activeFreeBet.id ? 'disabled' : ''
        }`}
        onClick={handleDoubleBet}
      >
        <div className='chips-action-inside'>
          <i className='icon-double' />
        </div>
      </div>
    </div>
  );
});
